import s from "./highrise1021.mjs";
import d from "./highrise987.mjs";
function m(o) {
  const {
    boxShadow2: r,
    popoverColor: e,
    textColor2: t,
    borderRadius: i,
    fontSize: n,
    dividerColor: a
  } = o;
  return Object.assign(Object.assign({}, s), {
    fontSize: n,
    borderRadius: i,
    color: e,
    dividerColor: a,
    textColor: t,
    boxShadow: r
  });
}
const p = {
  name: "Popover",
  common: d,
  self: m
};
export {
  p as default,
  m as self
};
